<template>
  <div>
    <div class="nav">
      <v-head></v-head>
    </div>
    <v-route :bindData="bindData"></v-route>
    <div class="container">
      <v-breadcrumb
        value1="首页"
        value2="玩转廉江"
        value3="美食"
        :value4="value4"
        :url="url"
      ></v-breadcrumb>

      <div class="container_box mt20 mb20">
        <div class="box_left">
          <div class="left_one shadow">
            <div class="one_one">
              <h3>{{ data.title }}</h3>
              <div class="time">
                <div>
                  <span v-if="data.rjxf != ''"
                    >人均消费：￥{{ data.rjxf }} 元</span
                  >
                  <span style="color: #008fff" @click="went"
                    >{{ commentsList }}条点评</span
                  >
                  <el-button style="margin-right:20px" type="text" @click="addXc(data)">添加行程规划</el-button>
                </div>
                <div class="rightIcon">
                  <div class="thumb">
                    <img
                      src="../../assets/img/点赞.png"
                      alt=""
                      v-if="isThumbs"
                      @click="beThumb"
                    />
                    <img
                      src="../../assets/img/已点赞.png"
                      alt=""
                      v-if="isThumbs1"
                      @click="beThumb"
                    />
                    <span>({{ ThumbNum }})</span>
                  </div>
                  <div class="collect">
                    <img
                      src="../../assets/img/收藏.png"
                      alt=""
                      v-if="isCollect"
                      @click="beCollect"
                    />
                    <img
                      src="../../assets/img/已收藏.png"
                      alt=""
                      v-if="isCollect1"
                      @click="beCollect"
                    />
                    <span>({{ CollectNum }})</span>
                  </div>
                </div>
              </div>
              <div v-html="data.content" class="cms_table mt20 mr20"></div>
            </div>
          </div>
          <div class="left_two shadow">
            <div class="two_nav">
              <el-tabs
                style="padding-top: 20px; margin: 0 20px"
                v-model="activeName"
                type="card"
              >
                <el-tab-pane label="推荐菜品" name="first">
                  <div class="first">
                    <div
                      class="first_item"
                      v-for="i in datalist"
                      @click="goTo(i.path)"
                    >
                      <img class="hover" :src="i.coverImageUrl" />
                      <h4 class="hover">{{ i.title }}</h4>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="交通位置" name="second">
                  <div id="container"></div>
                </el-tab-pane>
                <el-tab-pane label="餐厅周边" name="third">
                  <div id="container2"></div>
                  <div id="panel"></div>
                </el-tab-pane>
                <el-tab-pane label="猜你喜欢" name="fourth"
                  ><div class="first">
                     <div class="first_item" v-for="i in datalist" @click="goTo(i.path)">
                                        <img class="hover" :src="i.coverImageUrl">
                                        <h4 class="hover">{{i.title}}</h4>
                                    </div>
                  </div></el-tab-pane
                >
                <el-tab-pane label="食客点评" name="five">
                  <el-form
                    ref="form"
                    :model="form"
                    label-width="80px"
                    style="text-align: left"
                  >
                    <el-form-item label="我的评价:">
                      <el-radio v-model="form.wdpj" label="1" ><img src="../../assets/img/smile.png" style="position: relative;top: 5px;margin-right: 7px"></img>推荐</el-radio>
                                            <el-radio v-model="form.wdpj" label="2"><img src="../../assets/img/cry.png" style="position: relative;top: 5px;margin-right: 7px"></img>不推荐</el-radio>
                    </el-form-item>
                    <el-form-item label="印象标记:">
                      <el-radio v-model="form.yxbj" label="1"
                        >值得一去</el-radio
                      >
                      <el-radio v-model="form.yxbj" label="2">很好</el-radio>
                      <el-radio v-model="form.yxbj" label="3">一般</el-radio>
                      <el-radio v-model="form.yxbj" label="4">不好</el-radio>
                      <el-radio v-model="form.yxbj" label="5">很差</el-radio>
                    </el-form-item>
                    <el-form-item label="评价内容:">
                      <el-input
                        type="textarea"
                        :rows="4"
                        placeholder="请输入内容"
                        v-model="form.content"
                      ></el-input>
                    </el-form-item>

                    <el-form-item>
                      <el-button
                        style="width: 80px"
                        type="primary"
                        @click="toReview()"
                        >提交</el-button
                      >
                    </el-form-item>
                  </el-form>
                  <el-tabs v-model="activeName1" type="card">
                    <el-tab-pane label="全部" name="first">
                      <div class="from_item" v-for="i in comments">
                        <div class="item_title">
                          <span class="one">{{ i.username }}</span>
                          <span class="two">{{ i.createDate }}</span>
                          <span class="three" v-if="i.wdpj == 1">
                            <img src="../../assets/img/smile.png" />推荐</span
                          >
                          <span class="three" v-else>
                            <img src="../../assets/img/cry.png" />不推荐</span
                          >
                          <span class="four">{{ yxbj[i.yxbj] }}</span>
                        </div>
                        <p>{{ i.content }}</p>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="推荐" name="second">
                      <div
                        class="from_item"
                        v-for="i in comments"
                        v-if="i.wdpj == 1"
                      >
                        <div class="item_title">
                          <span class="one">{{ i.username }}</span>
                          <span class="two">{{ i.createDate }}</span>
                          <span class="three" v-if="i.wdpj == 1">
                            <img src="../../assets/img/smile.png" />推荐</span
                          >
                          <span class="three" v-else>
                            <img src="../../assets/img/cry.png" />不推荐</span
                          >
                          <span class="four">{{ yxbj[i.yxbj] }}</span>
                        </div>
                        <p>{{ i.content }}</p>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="不推荐" name="third">
                      <div
                        class="from_item"
                        v-for="i in comments"
                        v-if="i.wdpj == 2"
                      >
                        <div class="item_title">
                          <span class="one">{{ i.username }}</span>
                          <span class="two">{{ i.createDate }}</span>
                          <span class="three" v-if="i.wdpj == 1">
                            <img src="../../assets/img/smile.png" />推荐</span
                          >
                          <span class="three" v-else>
                            <img src="../../assets/img/cry.png" />不推荐</span
                          >
                          <span class="four">{{ yxbj[i.yxbj] }}</span>
                        </div>
                        <p>{{ i.content }}</p>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
        <div class="box_right">
          <div class="right_three shadow">
            <div class="three_title">
              <img src="../../assets/img/fj.png" /> 附近的餐厅
            </div>
            <div class="three_item" v-for="i in datalist">
              <img :src="i.coverImageUrl" />
              <div>
                <h4 class="hover" @click="goTo(i.path)">{{ i.title }}</h4>
                <span>{{ i.zanCount }}人点赞过</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-footer></v-footer>
  </div>
</template>

<script>
import route from "../../components/common/route1";
import icon from "../../assets/img/37310.gif";
import axios from 'axios'
export default {
  name: "list1",
  data() {
    return {
      commentsList: 0,
      productId: null,
      activeName: "first",
      activeName1: "first",
      value4: "",
      isThumbs: true,
      isCollect: true,
      isThumbs1: false,
      isCollect1: false,
      zan: false,
      sc: false,
      userId: "",
      ThumbNum: 0,
      CollectNum: 0,
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: 1,
        type: [],
        resource: "",
        desc: "",
      },
      data: {
        rjxf: null,
      },
      datalist: null,
      url: null,
      imgArr: [],
      comments: [],
      yxbj: {
        1: "值得一去",
        2: "很好",
        3: "一般",
        4: "不好",
        5: "很差",
      },
      bindData: [
        {
          name: "美食",
          url:
            "#/list_wzlj?ljcode=ms&columnId=40288a9d6e91c70a016e91cd018f000b&rootColumnId=40288a9d6e91c70a016e91c90be20002",
          cid: "40288a9d6e91c70a016e91cd018f000b",
        },
        {
          name: "住宿",
          url:
            "#/list_wzlj_zs?ljcode=zs&columnId=40288a9d6e91c70a016e91cd2d41000c&rootColumnId=40288a9d6e91c70a016e91c90be20002",
          cid: "40288a9d6e91c70a016e91cd2d41000c",
        },
        {
          name: "出行",
          url:
            "#/list_wzlj_cx?ljcode=cx&columnId=40288a9d6e91c70a016e91cd57a1000d&rootColumnId=40288a9d6e91c70a016e91c90be20002",
          cid: "40288a9d6e91c70a016e91cd57a1000d",
        },
        {
          name: "游玩",
          url:
            "#/list_wzlj_yw?ljcode=yw&columnId=40288a9d6e91c70a016e91cd7efb000e&rootColumnId=40288a9d6e91c70a016e91c90be20002",
          cid: "40288a9d6e91c70a016e91cd7efb000e",
        },
        {
          name: "购物",
          url:
            "#/list_wzlj_gw?ljcode=gw&columnId=40288a9d6e91c70a016e91cdd286000f&rootColumnId=40288a9d6e91c70a016e91c90be20002",
          cid: "40288a9d6e91c70a016e91cdd286000f",
        },
        {
          name: "娱乐",
          url:
            "#/list_wzlj_yl?ljcode=yl&columnId=40288a9d6e91c70a016e91ce074a0010&rootColumnId=40288a9d6e91c70a016e91c90be20002",
          cid: "40288a9d6e91c70a016e91ce074a0010",
        },
        {
          name: "特产",
          url:
            "#/list_wzlj_tc?ljcode=tc&columnId=40288a9d6e91c70a016e91ce50ae0011&rootColumnId=40288a9d6e91c70a016e91c90be20002",
          cid: "40288a9d6e91c70a016e91ce50ae0011",
        },
        {
          name: "红色景点",
          url:
            "#/list_wzlj_jd?ljcode=jd&columnId=ff808081758d28430175912d1564005e&rootColumnId=40288a9d6e91c70a016e91c90be20002",
          cid: "ff808081758d28430175912d1564005e",
        },
      ],
    };
  },
  methods: {
     addXc(v){
           window.location.href=`https://tour.i-lianjiang.cn/#/xcgh?ljcode=xcgh&columnId=40288a9d6e91c70a016e91d01e460017&rootColumnId=40288a9d6e91c70a016e91c982fd0004%3Fid%3D40288a9d6e91c70a016e91d01e460017&cid=${v.id}`
            },
    goTo(v) {
      this.imgArr = [];
      console.log(v);
      this.$router.push({ path: `/ms?${v}` });
    },
    goTo2() {
      location.href = `shop.html#/buy/ticket?id=${this.productId}&storeId=2625bfaa44a5a0ba408051a396a8a67be753fe1934a84bece44b6445a94e3331`;
    },
    initBindData() {
      switch (this.$route.query.columnId) {
        case "40288a9d6e91c70a016e91cd018f000b":
          this.bindData = [
            {
              name: "美食",
              url:
                "#/list_wzlj?ljcode=ms&columnId=40288a9d6e91c70a016e91cd018f000b&rootColumnId=40288a9d6e91c70a016e91c90be20002",
              cid: "40288a9d6e91c70a016e91cd018f000b",
            },
            {
              name: "住宿",
              url:
                "#/list_wzlj_zs?ljcode=zs&columnId=40288a9d6e91c70a016e91cd2d41000c&rootColumnId=40288a9d6e91c70a016e91c90be20002",
              cid: "40288a9d6e91c70a016e91cd2d41000c",
            },

            {
              name: "出行",
              url:
                "#/list_wzlj_cx?columnId=40288a9d6e91c70a016e91cd57a1000d&rootColumnId=40288a9d6e91c70a016e91c90be20002",
              cid: "40288a9d6e91c70a016e91cd57a1000d",
            },
            {
              name: "游玩",
              url:
                "#/list_wzlj_yw?ljcode=yw&columnId=40288a9d6e91c70a016e91cd7efb000e&rootColumnId=40288a9d6e91c70a016e91c90be20002",
              cid: "40288a9d6e91c70a016e91cd7efb000e",
            },
            {
              name: "购物",
              url:
                "#/list_wzlj_gw?ljcode=gw&columnId=40288a9d6e91c70a016e91cdd286000f&rootColumnId=40288a9d6e91c70a016e91c90be20002",
              cid: "40288a9d6e91c70a016e91cdd286000f",
            },
            {
              name: "娱乐",
              url:
                "#/list_wzlj_yl?ljcode=yl&columnId=40288a9d6e91c70a016e91ce074a0010&rootColumnId=40288a9d6e91c70a016e91c90be20002",
              cid: "40288a9d6e91c70a016e91ce074a0010",
            },
            {
              name: "特产",
              url:
                "#/list_wzlj_tc?ljcode=tc&columnId=40288a9d6e91c70a016e91ce50ae0011&rootColumnId=40288a9d6e91c70a016e91c90be20002",
              cid: "40288a9d6e91c70a016e91ce50ae0011",
            },
            {
              name: "红色景点",
              url:
                "#/list_wzlj_jd?ljcode=jd&columnId=ff808081758d28430175912d1564005e&rootColumnId=40288a9d6e91c70a016e91c90be20002",
              cid: "ff808081758d28430175912d1564005e",
            },
          ];
      }
    },

    init(arr, title) {
      var map1 = new AMap.Map("container", {
        resizeEnable: true,
        zoom: 18,
        center: [arr[1],arr[0]],
      });

      var marker = new AMap.Marker({
        position: new AMap.LngLat(arr[1], arr[0]), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        title: title,
      });

      map1.add(marker);
    },
    init2(arr, title) {
      var map = new AMap.Map("container2", {
        resizeEnable: true,
        zoom: 18,
        center: [arr[1],arr[0]],
      });
      var marker = new AMap.Marker({
        position: new AMap.LngLat(arr[1], arr[0]), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        title: title,
      });

      map.add(marker);
      AMap.service(["AMap.PlaceSearch"], function () {
        //构造地点查询类
        var placeSearch = new AMap.PlaceSearch({
          //      type: '住宿服务', // 兴趣点类别
          pageSize: 5, // 单页显示结果条数
          pageIndex: 1, // 页码
          city: "0759", // 兴趣点城市
          citylimit: true, //是否强制限制在设置的城市内搜索
          map: map, // 展现结果的地图实例
          panel: "panel", // 结果列表将在此容器中进行展示。
          autoFitView: true, // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
        });
        //关键字查询
        //   placeSearch.search('美食');

        var cpoint = [arr[1],arr[0]]; //中心点坐标
        placeSearch.searchNearBy("", cpoint, 200, function (status, result) {});
      });
    },
    getDetail() {
      let articleId = this.$route.query.articleId;
      let rootColumnId = this.$route.query.rootColumnId;
      let columnId = this.$route.query.columnId;
      this.url = ["wzlj", rootColumnId, columnId, "ms"];
      this.userId = localStorage.getItem("id");
      let url = `${api}/api/cms/article/detail?articleId=${articleId}&userId=${this.userId}`;
      this.common.axios.get(url).then((v) => {
        console.log(v.data.data);
        this.data = v.data.data;
        this.value4 = this.data.title;
        this.productId = this.data.productId;
        let arr = this.data.latlng.split(",");
        arr = arr.reverse();
        //地图周边
        this.init(arr, this.data.title);
        this.init2(arr, this.data.title);
        //图片集
        let arr2 = this.data.picList;
        arr2.forEach((v) => {
          this.imgArr.push(apiimg + v.imageUrl);
        });
        console.log(this.imgArr);
        this.CollectNum = this.data.scCount;
        this.ThumbNum = this.data.zanCount;
        this.zan = this.data.zan;
        this.sc = this.data.sc;
        if (this.zan == true) {
          this.isThumbs1 = true;
          this.isThumbs = false;
        } else if (this.zan == false) {
          this.isThumbs = true;
          this.isThumbs1 = false;
        }
        if (this.sc == true) {
          this.isCollect1 = true;
          this.isCollect = false;
        } else if (this.sc == false) {
          this.isCollect = true;
          this.isCollect1 = false;
        }
      });

      let url1 = `${api}/api/cms/article/zanlist?columnId=${columnId}`;
      this.common.axios.get(url1).then((v) => {
        let data = v.data.data.list;
        data.forEach((v) => {
          v.coverImageUrl = apiimg + v.cover_image_url;
          v.path = `rootColumnId=${rootColumnId}&columnId=${columnId}&articleId=${v.id}`;
        });
        this.datalist = data;
        console.log(this.datalist);
      });
    },
    beThumb() {
      if (this.userId != null) {
        let url2 = `${api}/api/cms/article/addZan?articleId=${this.$route.query.articleId}&userId=${this.userId}`;
        this.common.axios
          .get(url2)
          .then((res) => {
            console.log(res);
            if ((res.data.msg = "点赞成功")) {
              this.isThumbs = !this.isThumbs;
              this.isThumbs1 = !this.isThumbs1;
              this.ThumbNum = this.ThumbNum + 1;
              if (this.isThumbs == true) {
                this.$message.error("取消点赞");
                this.ThumbNum = this.ThumbNum - 2;
              } else if (this.isThumbs1 == true) {
                this.$message.success("点赞成功");
              }
            }
                 this.getDetail()
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (this.userId == null) {
        this.$message.error("请登录后点赞");
        return;
      }
    },
    beCollect() {
      if (this.userId != null) {
        let url3 = `${api}/api/cms/article/addCollect?articleId=${this.$route.query.articleId}&userId=${this.userId}`;
        this.common.axios
          .post(url3)
          .then((res) => {
            console.log(res);
            this.isCollect = !this.isCollect;
            this.isCollect1 = !this.isCollect1;
            if (this.isCollect == true) {
              this.$message.error("取消收藏");
              this.CollectNum = this.CollectNum - 1;
              console.log(typeof this.CollectNum);
            } else if (this.isCollect1 == true) {
              this.$message.success("收藏成功");
              this.CollectNum = this.CollectNum + 1;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (this.userId == null) {
        this.$message.error("请登录后收藏");
        console.log(this.$route.query.articleId, 123);
      }
    },
    toReview() {
      let that = this;
      let user = localStorage.getItem("userdb");
      if (!user || Date.parse(new Date()) - user.timein > 24 * 60 * 60 * 1000) {
        this.$confirm("您还未登录或已身份过期,请登录后再进行评价!", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            that.common.loginwx();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消登录",
            });
          });
      } else {
        let obj = JSON.parse(user);
        let url = `${api}/api/comments/addComments`;
        // let url = 'http://192.168.10.19:8080/lianjiang_web_i/api/comments/addComments'
        if (
          this.form.wdpj == null ||
          this.form.yxbj == null ||
          this.form.content == null
        ) {
          this.$message.error("评价不能为空");
          return false;
        }
        //target: 'https://cms.zlyun168.com/lianjiang_web_i',
        let params = {
          wdpj: this.form.wdpj,
          yxbj: this.form.yxbj,
          content: this.form.content,
          yuser: {
            id: obj.userId,
          },
          article: {
            id: this.$route.query.articleId,
          },
        };
        this.common.axios.post(url, params).then((v) => {
          if (v.status == 200) {
            this.$message.success("评价成功!等审核之后就可以看到了");
            this.comments = [];
            this.form = [];
            this.getContents();
          }
        });
      }
    },
    went() {},
    getContents() {
      let url = `${api}/api/comments/list?articleId=${this.$route.query.articleId}`;
      this.common.axios.get(url).then((v) => {
        console.log(v.data.data, 123123);
        let data = v.data.data.list;

        data.forEach((v) => {
          this.comments.push({
            createDate: this.common.date2Local(v.createDate),
            wdpj: v.wdpj,
            yxbj: v.yxbj,
            username: v.yuser.nickname,
            content: v.content,
          });
        });
        this.commentsList = v.data.data.totalCount;
        console.log(this.comments);
        // console.log(v);
      });
    },
  },
  components: {
    "v-route": route,
  },
  watch: {
    $route: function (newValue) {
      console.log(newValue);
      this.$route.query.articleId = newValue.query.articleId;
      this.$route.query.rootColumnId = newValue.query.rootColumnId;
      this.$route.query.columnId = newValue.query.columnId;
      this.getDetail();
      this.comments = [];
      this.getContents();
    },
  },
  created() {
    this.getDetail();
    this.getContents();
  },
  mounted() {
    //    this.init();
    //     this.init2();
  },
};
</script>

<style lang="less" scoped>
#panel {
  position: absolute;
  background-color: white;
  max-height: 90%;
  overflow-y: auto;
  top: 10px;
  right: 10px;
  width: 280px;
}
.nav {
  height: 350px;
  background: url("../../assets/img/headerbanner.jpg");
}
.container_box {
  display: flex;
  flex-direction: row;
  .box_left {
    width: 820px;
    margin-right: 20px;
    .left_one {
      min-height: 880px;
      margin-bottom: 20px;
      overflow: auto;
      .one_one {
        text-align: left;
        > .time {
          display: flex;
          width: 90%;
          justify-content: space-between;
          margin-left: 0;
          > .rightIcon {
            display: flex;
            width: 20%;
            justify-content: space-between;
            align-items: center;
            > .thumb {
              display: flex;
              align-items: center;
              > img {
                width: 18px;
                cursor: pointer;
              }
              > span {
              }
            }
            > .collect {
              display: flex;
              align-items: center;
              > img {
                width: 18px;
                margin-right: 6px;
                cursor: pointer;
              }
              > span {
                margin-right: 40px;
              }
            }
          }
        }
        h3 {
          display: inline-block;
          margin: 25px 0 30px 20px;
          height: 42px;
          font-size: 30px;
          font-weight: 500;
          color: rgba(62, 62, 62, 1);
          line-height: 42px;
        }
        div {
          margin-left: 20px;
          height: 22px;
          font-size: 16px;
          font-weight: 400;
          color: rgba(150, 150, 150, 1);
          line-height: 22px;
          span {
            margin-right: 30px;
          }
        }
      }
    }
    .left_two {
      //  min-height: 824px;
      .first {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .first_item {
          width: 240px;
          margin-bottom: 20px;
          text-align: left;
          margin-right: 20px;
          img {
            width: 240px;
            height: 200px;
          }
          h4 {
            display: inline-block;
            //     width:84px;
            height: 20px;
            font-size: 14px;
            font-weight: 500;
            color: rgba(62, 62, 62, 1);
            line-height: 20px;
            margin-top: 10px;
          }
        }
      }
      #container {
        height: 800px;
        width: 100%;
      }
      #container2 {
        height: 800px;
        width: 100%;
      }
      .from_item {
        margin-top: 10px;
        text-align: left;
        min-height: 148px;
        .item_title {
          display: flex;
          align-items: center;
          height: 22px;
          justify-content: space-between;
          .one {
            display: inline-block;
            width: 96px;
            height: 22px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(255, 133, 97, 1);
            line-height: 22px;
            margin-right: 25px;
          }
          .two {
            display: inline-block;
            width: 87px;
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(150, 150, 150, 1);
            line-height: 20px;
            margin-right: 190px;
          }
          img {
            width: 22px;
            height: 20px;
            margin-right: 15px;
          }
          .three {
            width: 120px;
            height: 22px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 22px;
            display: flex;
            align-items: center;
          }
          .four {
            display: inline-block;
            text-align: center;
            color: #666666;
            font-size: 12px;
            width: 64px;
            height: 24px;
            line-height: 24px;
            background: rgba(249, 249, 249, 1);
            border: 1px solid rgba(238, 238, 238, 1);
          }
        }
        p {
          margin-top: 11px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 17px;
        }
        border-bottom: 1px solid rgba(238, 238, 238, 1);
      }
    }
  }
  .box_right {
    width: 360px;
    .right_one {
      height: 470px;
    }
    .right_three {
      height: 756px;
      overflow: auto;
      //   padding-top: 20px;
      .three_title {
        text-align: left;
        height: 17px;
        line-height: 17px;
        color: #fdaa18;
        font-size: 16px;
        display: flex;
        align-items: center;
        margin: 20px 0 10px 21px;
        img {
          margin-right: 10px;
        }
      }
      .three_item {
        margin: 0 15px 15px 15px;
        height: 104px;
        display: flex;
        img {
          width: 104px;
          height: 104px;
          margin-right: 15px;
        }
        div {
          text-align: left;
          flex: 1;
          h4 {
            width: 200px;
            height: 22px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(0, 143, 255, 1);
            line-height: 22px;
            display: inline-block;
          }
          span {
            display: inline-block;
            margin-top: 20px;

            height: 22px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(253, 170, 24, 1);
            line-height: 22px;
          }
        }
      }
    }
  }
}
</style>

<style lang="less">
.first {
  text-align: justify;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  p {
    text-indent: 0em !important;
    line-height: 32px !important;
    font-size: 14px !important;
    color: #666666 !important;
    margin-bottom: 32px !important;
    span {
      font-size: 14px !important;
      color: #666666 !important;
    }
  }
  img {
    max-width: 100% !important;
  }
}

.left_one::-webkit-scrollbar {
  /*滚动条整体样式*/

  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/

  height: 1px;
}

.left_one::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/

  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #edb98c;
}

.left_one::-webkit-scrollbar-track {
  /*滚动条里面轨道*/

  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #f7eadf;
}

.right_three::-webkit-scrollbar {
  /*滚动条整体样式*/

  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/

  height: 1px;
}

.right_three::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/

  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #edb98c;
}

.right_three::-webkit-scrollbar-track {
  /*滚动条里面轨道*/

  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #f7eadf;
}
</style>
